import { Image } from '@frontend/design-system';

export const ImageComponent = Image;
